import { createRef, FC } from 'react';
import useCloseClick from '../hooks/useCloseClick';
import { isUserLoggedIn, removeUserDataFromLocalStorage } from '../utils/auth';
import { NALOG, PUBLIC_API } from '../constants/config';
import ProfileIcon from '../assets/images/icons/icon-no-profile.png';
import AccountIcon from '../assets/images/icons/icon-account.svg';
import { LOCAL_STORAGE_KEYS } from '../constants/localStorageKeys.ts';
import { Link } from 'react-router-dom';
import { Config } from '../utils/menu.ts';
import '../scss/yettel-profile-menu.scss';

type Props = object;

const HeaderProfile: FC<Props> = () => {
  const detailsRef = createRef<HTMLDetailsElement>();
  const profileUrl = localStorage.getItem(LOCAL_STORAGE_KEYS.AVATAR_URL);
  useCloseClick(detailsRef);
  const isLoggedIn = isUserLoggedIn();

  const handleLogout = async () => {
    removeUserDataFromLocalStorage();
    await fetch(`${PUBLIC_API}/auth`, { method: 'DELETE' });

    if (import.meta.env.PROD === true) {
      window.location.replace(
        `${NALOG}/app/logout?post_logout_redirect_uri=${window.location.href}`
      );
    } else {
      window.location.reload();
    }
  };

  return (
    <div className="yettel-profile-menu mr-1">
      <details ref={detailsRef} data-popover="down">
        <summary className="d-block">
          <div className="ytl-icon-container"></div>
          <img
            className="icon"
            alt="yettel-menu"
            src={isLoggedIn ? profileUrl || ProfileIcon : AccountIcon}
            width={32}
          />
        </summary>
        <div className="ytl-popover-menu-list">
          {isLoggedIn ? (
            <a
              href={Config.tnAccountSettingUrl}
              className="ytl-menu-item"
              target="_blank"
              rel="noreferrer"
            >
              <div className="ytl-menu-item-text">
                <p>Yettel profil</p>
              </div>
            </a>
          ) : (
            <Link to="/profil" className="ytl-menu-item" target="_blank">
              <div className="ytl-menu-item-text">
                <p>Prijavi se</p>
              </div>
            </Link>
          )}
          {isLoggedIn && (
            <a onClick={handleLogout} className="ytl-menu-item">
              <div className="ytl-menu-item-text">
                <p>Odjavi se</p>
              </div>
            </a>
          )}
        </div>
      </details>
    </div>
  );
};

export default HeaderProfile;
